import { render } from "./sel-expansion.vue?vue&type=template&id=d81a2f16&scoped=true"
import script from "./sel-expansion.vue?vue&type=script&lang=js"
export * from "./sel-expansion.vue?vue&type=script&lang=js"

import "./sel-expansion.vue?vue&type=style&index=0&id=d81a2f16&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81a2f16"]])

export default __exports__